<div class="modal-header">
    <h4 class="modal-title">{{ 'DeleteConfirmation' | translate }}</h4>
    <div>
        <i class="fe fe-x black-menu" ngbTooltip="{{ 'Close' | translate }}" (click)="activeModal.dismiss()"></i>
    </div>
</div>
<div class="modal-body">
    {{ message | translate }}
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-sm btn-light" (click)="activeModal.dismiss()">
        <i class="fe fe-x"></i>
        <span>{{ 'Cancel' | translate }}</span>
    </button>
    <button class="btn btn-sm btn-danger" [disabled]="(httpService.getLoading('actionDeleteLoader'))"
        (click)="delete()">
        <ng-container *ngIf="(httpService.getLoading('actionDeleteLoader'))">
            <span class="spinner-border spinner-border-sm" role="status"></span>
            <span>{{ 'Deleting' | translate }}...</span>
        </ng-container>
        <ng-container *ngIf="!(httpService.getLoading('actionDeleteLoader'))">
            <i class="fe fe-trash-2"></i>
            <span>{{ 'Delete' | translate }}</span>
        </ng-container>
    </button>
</div>